import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';
import { findIndex, includes, isNil, propEq } from 'ramda';
import { createAction } from 'redux-actions';

import { replaceData, resetForm, setValue } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import { COMPANY } from 'constants/general';
import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import documents from 'features/views/production/documents';
import { trimFormData } from 'utils';

import { sellerInCPLength } from '../policyOverview/constants';
import * as types from './actionTypes';
import { sellerNumbersSourceForProducedProduction } from './constants';
import { FIELDS, PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME } from './form';
import { documentsBodyFactory } from './utils';

export const setSellerNumbers = createAction(types.SET_SELLER_NUMBERS, (sellerNumbers) => ({ sellerNumbers }));
export const setEditMode = createAction(types.SET_EDIT_MODE, (on) => ({ on }));
export const reset = createAction(types.RESET);
export const productionSaved = createAction(types.PRODUCTION_SAVED);

export const loadUsersSellerNumbers =
	(login) =>
	(dispatch, getState, { sendControlNext }) => {
		dispatch(
			fetch.actions.get(fetch.constants.urls.userSellerIns, {
				queryParams: {
					source: sellerNumbersSourceForProducedProduction,
					login,
					filterCompany: true,
					companyId: COMPANY.CP,
				},
				onSuccess: [
					(response) => () => {
						const hasValues = response && response.body;
						if (!hasValues) return;
						const activeSellerNumbers = response.body
							.filter((sellerNumber) => sellerNumber.active)
							.filter((sellerNumber) => {
								return String(sellerNumber.sellerIn).length === sellerInCPLength;
							})
							.map((sellerNumber) => sellerNumber.sellerIn);

						const indexMainSeller = findIndex(propEq(true, 'main'))(response.body);
						const mainSellerNumber = indexMainSeller >= 0 ? activeSellerNumbers[indexMainSeller] : null;

						if (activeSellerNumbers.length === 1) {
							sendControlNext(
								PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME,
								setValue({ fieldName: FIELDS.sellerIn, value: activeSellerNumbers[0] }),
							);
						}

						if (activeSellerNumbers.length > 1 && !isNil(mainSellerNumber) && includes(mainSellerNumber)) {
							sendControlNext(
								PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME,
								setValue({ fieldName: FIELDS.sellerIn, value: mainSellerNumber }),
							);
						}

						dispatch(setSellerNumbers(activeSellerNumbers));
					},
				],
			}),
		);
	};

const onAddSuccess =
	(type) =>
	async (dispatch, getState, { getFormData, sendControlNext }) => {
		const formData = await getFormData(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME);

		if (type === 'add') {
			dispatch(productionSaved());
			sendControlNext(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME, resetForm());
			const finalData = {
				sellerIn: formData?.sellerIn,
			};

			sendControlNext(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME, replaceData({ data: finalData }));
		} else {
			NiceModal.hide(MODALS.producedProduction_new);
		}
		dispatch(dialog.actions.close(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME));
		dispatch(resetErrorsByPage({ page: PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME }));
	};

export const createOrUpdateDocument =
	(type) =>
	async (dispatch, getState, { getFormData }) => {
		const state = getState();

		// validation is handled by submitButton + dialogs by submitFormDialog
		const producedProductionNewFormData = await getFormData(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME);
		const formData = trimFormData(producedProductionNewFormData);

		dispatch(
			fetch.actions.post(fetch.constants.urls.productionDocument, {
				uniqueReqID: type,
				body: documentsBodyFactory(formData),
				onSuccess: [
					() => () => {
						const fetchState = fetch.selectors.getFetchState(fetch.constants.urls.productionDocuments)(
							state,
						);
						if (fetchState.loaded) {
							dispatch(documents.actions.reload());
						} else {
							dispatch(documents.actions.submitDocuments());
						}
						dispatch(onAddSuccess(type));

						enqueueSnackbar(getMessage('toastr:approveSaveDocument'), { variant: 'success' });
					},
				],
			}),
		);
	};
